<template>
	<div class="page">
		<div class="searchBox">
			<el-row>
				<el-col :span="4" >
					<span style="font-size: 18px;font-weight: bold;line-height: 40px;">编辑商品</span>
				</el-col>
				<el-col :span="8" :offset="12" style="text-align: right;">
					<el-button style="width:100px;" type="primary" :loading="loading" @click='submit'>提交</el-button>
					<el-button type="warning" @click="isBack" >返回</el-button>
				</el-col>
			</el-row>
		</div>
		<el-form ref="form" class="formBox" label-width="100px">
			<div class="add2-content">
				<div class="left">
					<div class="tit">
						<span class="name">基础设置</span>
					</div>
					<el-form-item label="商品分类" v-if="treeList.length > 0">
						<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds" :options="treeList[0].children" :show-all-levels="true" :props="{ label: 'label',value:'id' }" @change="changeCategory"></el-cascader>
					</el-form-item>
					<el-form-item label="品牌名:" class=" mandatory" >
						<el-select class="input" v-model="editParams.brand_name" filterable placeholder="请选择" size="mini" v-if="$public.isNull($route.query.id)">
							<el-option :label="item.name" :value="item.name" v-for="item in brandList" :key="item._id" >
							</el-option>
						</el-select>
						<span v-else>{{editParams.brand_name}}</span>
					</el-form-item>
					<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='(d)=>{editParams.shop_info = d}'></storeSelect>
					<el-form-item label="适用品种" >
						<el-radio-group v-model="editParams.applyType">
							<el-radio label="0">通用</el-radio>
							<el-radio label="1">猫用</el-radio>
							<el-radio label="2">犬用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="是否复购">
						<el-radio-group v-model="editParams.buy_back">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="系列名称" >
						<el-select class="input" v-model="editParams.series_name" filterable placeholder="请选择" size="mini">
							<el-option :label="item.name" :value="item.name" v-for="item in seriesList" :key="item.value" >
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="最小库存预警 " >
						<el-input v-model.number="editParams.stock_alert" size="mini" style="width: 193px;" placeholder="请输入库存下限"></el-input>
					</el-form-item>
					<el-form-item label="商品描述">
						<el-input v-model="editParams.desc" size="mini" style="width: 200px;" placeholder="请输入商品描述"></el-input>
					</el-form-item>
					<el-form-item label="商品备注 :">
						<el-input v-model="editParams.remark" type="textarea" :rows="2" placeholder="请输入内容" style="width: 193px;" ></el-input>
					</el-form-item>
				</div>
				<div class="right" ref='skucontent'>
					<div class="tit">
						<span class="name">附加属性</span>
					</div>
					<span style="font-size: 14px;color:red;">请谨慎添加/编辑/删除规格，此规格的添加，将会在小程序，商品库，打印条码处共同展示！</span>
					<span style="font-size: 14px;color:red;">若进行删除，重新编辑，请尽可能的通知到与商品相关的人员。</span>
					<div class="skucontent">
						<div class="skuitem" v-for="(skuitem,skuindex) in editParams.skuList" :key='skuindex'>
							<div style="text-align: center;font-size: 16px;color:#FF0000;margin-top: 10px;">商品{{skuindex+1}}</div>
							<el-form-item label-width="110px" v-for="(skuinfo,index) in skuitem.skuInfo" :key='index' :label="skuinfo.name" class="formitemsku">
								<el-input v-model="skuinfo.value" size="mini" :disabled='skuitem.status==0' style="width: 150px" :placeholder="'请输入'+skuinfo.name"></el-input>
								<el-button v-if="skuitem.skuInfo.length>1&&skuindex==0" type="text" style="margin-left: 10px;" @click='deleteSkuinfo(index)'>删除</el-button>
							</el-form-item>
							<div style="text-align: center;font-size: 16px;color:#FF0000;margin-top: 10px;">
								<template v-if="skuindex==0">
									<el-popover popper-class='popover' placement="bottom" width="160" v-model="skuDailog">
										<div>规格名称</div>
										<el-input v-model="skuName" size="mini" style="width: 160px;margin-top: 10px" placeholder="请输入规格名称"></el-input>
										<div style="text-align: right; margin-top: 10px">
											<el-button size="mini" type="text" @click="skuDailog = false">取消</el-button>
											<el-button type="primary" size="mini" @click='addSku'>确定</el-button>
										</div>
										<el-button slot="reference" size="mini" type="warning" style="margin-left: 10px;">添加规格</el-button>
									</el-popover>
								</template>
								<el-button v-if="!$public.isNull(skuitem.skuId)&&skuitem.status==1" style="text-align: center;margin-left: 10px;" type="warning" size="mini" @click='skuitem.status=0'>作废</el-button>
								<el-button v-if="!$public.isNull(skuitem.skuId)&&skuitem.status==0" style="text-align: center;margin-left: 10px;" type="danger" size="mini" @click='skuitem.status=1'>取消作废</el-button>
								<el-button v-if="$public.isNull(skuitem.skuId)&&editParams.skuList.length>1" style="text-align: center;" type="danger" size="mini" @click='editParams.skuList.splice(skuindex, 1)'>删除 </el-button>
								<el-button style="text-align: center;margin-left: 10px;" type="primary" size="mini" @click='copy(skuitem)'>复制</el-button>
							</div>
							<div class="totaltitle">
								<div style="margin: 10px;font-size: 18px;color:fuchsia">
									<div v-if="editParams.category_info.name">
										{{editParams.category_info.name}}类
									</div>
									<div style="padding-top:4px;">
										{{editParams.brand_name}} {{editParams.series_name}}
										<span v-if="editParams.applyType=='0'">通用</span>
										<span v-if="editParams.applyType=='1'">猫用</span>
										<span v-if="editParams.applyType=='2'">狗用</span>
									</div>
									<div style="padding-top:4px;font-size: 16px;">
										<span v-for="(skuinfo,index) in skuitem.skuInfo" :key='index'>
											<span v-if="skuinfo.value.length>0">
												{{skuinfo.value}}
											</span>
										</span>
									</div>
								</div>
								<div style="margin-top: 10px;">
									<el-form-item label="包装方式" label-width="80px">
										<div v-for="(pakage,pakageIndex) in skuitem.packingInfo" :key='pakageIndex'>
											<span v-if="pakageIndex==0">
												<el-select v-model="pakage.bigPacking" style="width: 172px;" size="small" placeholder="请选择" @change="(val)=>changepackage(skuindex)">
													<el-option v-for="item in unitList" :key="item.name" :label="item.name" :value="item.name"></el-option>
												</el-select>
											</span>
											<div v-if="pakage.bigPacking" >
												1 {{pakage.bigPacking}} /
												<el-input v-model="pakage.smallPackingCount" size="small" style="width: 70px;margin-right: 5px;" ></el-input>
												<el-select v-model="pakage.smallPacking" style="width: 60px;" size="small" placeholder="请选择" @change="(val)=>changepackage(skuindex)">
													<el-option v-for="item in unitList" :key="item.name" :label="item.name" :value="item.name"></el-option>
												</el-select>
												<el-button v-if="pakageIndex+1==skuitem.packingInfo.length" type="text" style="margin-left: 10px;" @click='addpakage(pakageIndex,skuindex)'>新建</el-button>
												<el-button v-if="pakageIndex>0" type="text" style="margin-left: 10px;" @click='deletepakage(pakageIndex,skuindex)'>删除</el-button>
											</div>
										</div>
									</el-form-item>
								</div>
								<div>
									<el-form-item label="销售方式" label-width="80px">
										<div v-for="(pakage,pakageIndex) in skuitem.packingPrice" :key='pakageIndex'>
											1 {{pakage.name}} = 价格
											<el-input size="small" style="width: 100px;margin-left: 5px;" v-model="pakage.pprice" placeholder="请输入销售价"></el-input>
										</div>
									</el-form-item>
								</div>
								<div v-if="!$public.isNull($route.query.id)">
									<el-form-item label="状态" label-width="80px">
										<el-radio-group v-model="skuitem.status">
											<el-radio :label="1">启用</el-radio>
											<el-radio :label="0">暂停</el-radio>
											<el-radio :label="-1">作废</el-radio>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-form>
	</div>
</template>
<script>
	import storeSelect from "../../../components/storeSelect.vue"
	export default {
		components: { storeSelect, },
		data() {
			return {
				// 分类
				productTypeIds: [],
				treeList: [],
				// 品牌
				brandList: [],
				// 适用门店
				storeIds: [],
				showShops: false,
				// 系列名称
				seriesList:[],
				
				editParams: {
					"goodsId": "",
					"brand_name": "",
					"series_name": "",  // 系列
					"applyType": '0',  // 0通用   1猫  2狗
					"title": "",
					"buy_back":1,  // 是否复购
					"category_info": {
						"_id": "",
						"name": "",
						"code": "",
						category_list:[],
					},
					"category_list": [{
						"_id": "",
						"name": "",
						"code": ""
					}],
					"stock_alert": 1,  // 最小库存预警
					"shop_info": [],  // 适用门店
					"desc": "",  // 商品描述
					"remark": "",  // 商品备注
					"skuList": [{
						"skuId": "",
						skuInfo: [{
								value: '',
								name: '适用年龄段'
							},
							{
								value: '',
								name: '宠物类型'
							},
							{
								value: '',
								name: '功效/功能'
							},
							{
								value: '',
								name: '用法'
							},
							{
								value: '',
								name: '形状'
							}, {
								value: '',
								name: '味道'
							},
							{
								value: '',
								name: '材质'
							},
							{
								value: '',
								name: '款式/颜色/花纹'
							},
							{
								value: '',
								name: '时效'
							},
							{
								value: '',
								name: '尺寸/重量/体积'
							},
							{
								value: '',
								name: '包装方式'
							},
							{
								value: '',
								name: '规格'
							},
						],
						"status": 1,
						"packingInfo": [{
							"bigPacking": "",
							"smallPacking": "",
							"smallPackingCount": 0
						}],
						"packingPrice": []
					}],
				},
				// 添加新规格
				skuDailog: false,
				skuName: '',
				// 包装单位
				unitList: [],
				 
				loading: false,
			}
		},
		created() {
			this.getTree();
			this.getSeriesList()
			this.getUnitList();
			if (this.$route.query.id) {
				this.getProductGoodsDl(this.$route.query.id)
			} else {
				this.getBrandList()
				this.editParams.shop_info = this.$store.state.allShopList
			}
		},
		methods: {
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back()
				})
			},
			// 修改商品分类 tree
			changeCategory(val) {
				if (val.length > 0) {
					this.$http.get(process.env.VUE_APP_baseData+'/api/dict/ProductType/codemodel', { id: val[val.length - 1] }).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_info.code = res.data.code;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
			// 规格项
			deleteSkuinfo( skuinfoindex) {
				this.editParams.skuList.forEach(item => {
					item.skuInfo.splice(skuinfoindex, 1)
				})
			},
			addSku() {
				if (this.$public.isNull(this.skuName)) {
					this.$message.error('请输入规格名称');
				} else {
					this.editParams.skuList.forEach(item => {
						item.skuInfo.splice(item.skuInfo.length - 3, 0, {
							name: this.skuName,
							value: ''
						})
					})
					this.skuDailog = false;
				}
			},
			copy(skuitem) {
				let skuitemdata = Object.assign({}, JSON.parse(JSON.stringify(skuitem)));
				skuitemdata.skuId = '';
				this.editParams.skuList.push(skuitemdata);
			},
			// 包装方式
			changepackage(skuindex) {
				var packingInfoData = [];
				this.editParams.skuList[skuindex].packingInfo.forEach(item => {
					packingInfoData.push(item.bigPacking)
					packingInfoData.push(item.smallPacking)
				})
				this.editParams.skuList[skuindex].packingPrice = [];
				new Set(packingInfoData).forEach(item => {
					if (item) {
						this.editParams.skuList[skuindex].packingPrice.push({
							"name": item,
							"pprice": 0,
						})
					}
				})
			},
			addpakage(pakageIndex,skuindex) {
				if (this.$public.isNull(this.editParams.skuList[skuindex].packingInfo[pakageIndex].smallPacking)) {
					this.$message.error('请输入包装名称');
				} else {
					this.editParams.skuList[skuindex].packingInfo.push({
						"bigPacking": this.editParams.skuList[skuindex].packingInfo[pakageIndex].smallPacking,
						"smallPacking": "",
						"smallPackingCount": 0,
					})
				}
			},
			deletepakage(pakageIndex,skuindex) {
				var packingInfoData = [];
				this.editParams.skuList[skuindex].packingInfo.splice(pakageIndex, 1)
				this.editParams.skuList[skuindex].packingInfo.forEach(item => {
					packingInfoData.push(item.bigPacking)
					packingInfoData.push(item.smallPacking)
				})
				this.editParams.skuList[skuindex].packingPrice = [];
				new Set(packingInfoData).forEach(item => {
					if (item) {
						this.editParams.skuList[skuindex].packingPrice.push({
							"name": item,
							"pprice": 0,
						})
					}
				})
			},
			// 提交修改
			submit() {
				this.loading = true;
				if(this.$public.isNull(this.editParams.category_info._id)){
					this.$message({
						message: '商品分类不能为空',
						type: 'error'
					});
					this.loading = false;
					return ;
				}
				if(this.$public.isNull(this.editParams.brand_name)){
					this.$message({
						message: '品牌不能为空',
						type: 'error'
					});
					this.loading = false;
					return ;
				}
				for(let i=0;i<this.editParams.skuList.length;i++){
					let sku = ''
					for(let a=0;a<this.editParams.skuList[i].skuInfo.length;a++){
						if(!this.$public.isNull(this.editParams.skuList[i].skuInfo[a].value)){
							sku+=this.editParams.skuList[i].skuInfo[a].value
						}
					}
					if(sku.length===0){
						this.$message({
							message: '规格不能为空',
							type: 'error'
						});
						this.loading = false;
						return ;
					}
					if(this.$public.isNull(this.editParams.skuList[i].packingInfo[0].bigPacking)){
						this.$message({
							message: '请选择包装方式',
							type: 'error'
						});
						this.loading = false;
						return ;
					}
				}
				let name;
				if (this.editParams.applyType == '0') {
					name = '通用'
				} else if (this.editParams.applyType == '1') {
					name = '猫用'
				} else if (this.editParams.applyType == '2') {
					name = '狗用'
				}
				this.editParams.title = `${this.editParams.brand_name} ${this.editParams.series_name}  ${name}`
				this.$http.post(process.env.VUE_APP_baseData+'/api/product/goods/update', this.editParams).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.$message({
							message: '添加成功',
							type: 'success'
						});
						this.$router.back()
					}
				})
			},
			getProductGoodsDl(id) {
				this.$http.get(process.env.VUE_APP_baseData+'/api/product/goods/simple', { id }).then(res => {
					if (res.code == 0) {
						this.editParams = res.data;
						this.productTypeIds = [];
						res.data.category_list.forEach((item, index) => {
							if (index > 0) {
								this.productTypeIds.push(item._id)
							}
						})
						this.productTypeIds.push(res.data.category_info._id);
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						this.showShops = true;
					}
				})
			},
			getTree() {
				this.$http.get(process.env.VUE_APP_baseData+'/api/dict/ProductType/tree', { category: '商品' }).then(res => {
					if (res.code == 0) {
						this.treeList = res.data;
					}
				})
			},
			getBrandList() {
				this.$http.post(process.env.VUE_APP_baseData+'/api/dict/BrandInfo/list', {
					keyword:'',
					pageIndex: 0,
					pageSize: 0
				}).then(res => {
					this.brandList = res.data.data;
				})
			},
			getSeriesList() {
				this.$http.post(process.env.VUE_APP_baseData+'/api/GoodsOtherInfo/SeriesList', { keyword: '' }).then(res => {
					this.seriesList = res.data
				})
			},
			getUnitList() {
				this.$http.post(process.env.VUE_APP_baseData+'/api/dict/ProductType/list', { category: '包装单位' }).then(res => {
					if (res.code == 0) {
						this.unitList = res.data.data;
					}
				})
			},
		},
	}
</script>
<style lang="scss" scoped="scoped">
	.page {
		padding: 10px 16px 16px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;
		.searchBox {
			.el-form-item {
				margin-bottom: 0;
			}
		}
		.formBox{
			height: calc(100% - 47px);margin-top:10px;background-color: #fff;border-radius: 8px;padding:10px;box-sizing: border-box;position: relative;
			.add2-content {
				display: flex;justify-content: flex-start;height: 100%;
				.left {
					width: 340px;flex-shrink: 0;box-sizing: border-box;/* border-right: 1px dotted #666; */
					.tit {
						font-size: 16px;margin-bottom: 10px;height: 20px;line-height: 20px;border-radius: 3px;
						.name {
							padding-left: 5px;
							border-left: 2px solid #F5882A;
						}
					}
					.baseinfo {
						border-bottom: 1px dotted #666;
					}
				}
				.right {
					width: 100%;
					overflow-y: scroll;
					padding:0 0 0 10px;
					.tit {
						font-size: 16px;margin-bottom: 10px;height: 20px;line-height: 20px;border-radius: 3px;
						.name {
							padding-left: 5px;
							border-left: 2px solid #F5882A;
						}
					}
					.skucontent {
						display: flex;
						flex-wrap: wrap;
						justify-content: flex-start;
						margin-top: 10px;
						.totaltitle {
							margin: 10px 10px;font-size: 14px;background-color: #DEE6FA;padding:10px;border-radius: 5px;
						}
						.skuitem {
							width: 390px;border: 1px dotted #666;margin:2px;
						}
					}
				}
			}
		}
		.formitem {
			margin-bottom: 0px;
		}
		.formitemsku {
			margin-bottom: 0px;
			// width: 300px;
		}
		.formitemlable {
			.el-form-item__label {
				color: red;
			}
		}
		.mandatory {
			margin-bottom: 10px;
		}
	}
</style>
